module.exports = __webpack_public_path__ + "img/sort-light.ae40fa21.svg";